import script from "./AdminProductCategoryDetailView .vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProductCategoryDetailView .vue?vue&type=script&setup=true&lang=js"

import "./AdminProductCategoryDetailView .vue?vue&type=style&index=0&id=3eca08b9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3eca08b9"]])

export default __exports__